module.exports = __webpack_public_path__ + "static/media/insurance.e525859f.svg";